import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { convertGenderToCorrectValue } from '../../../../utils';
import { Gender } from '@websky/graphql';
import { CdnIcon } from '@shared/ui';
export const PassengerSwitch = props => {
    var _a;
    const { PassengerSwitch: theme } = useTheme('Passenger');
    const [selectedOption, setSelectedOption] = React.useState(convertGenderToCorrectValue((_a = props.value) !== null && _a !== void 0 ? _a : ''));
    const formattedOptions = React.useMemo(() => props.options.map(option => {
        const genderValue = convertGenderToCorrectValue(option.value);
        return {
            key: genderValue,
            label: option.label,
            icon: genderValue === Gender.Male ? React.createElement(CdnIcon, { icon: "Info/Male" }) : React.createElement(CdnIcon, { icon: "Info/Female" })
        };
    }), [props.options]);
    const onChange = (event) => {
        var _a, _b;
        setSelectedOption(event.target.value);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event.target.value, event);
        (_b = props.onBlur) === null || _b === void 0 ? void 0 : _b.call(props);
    };
    React.useEffect(() => {
        var _a;
        setSelectedOption(convertGenderToCorrectValue((_a = props.value) !== null && _a !== void 0 ? _a : ''));
    }, [props.value]);
    return (React.createElement("div", { className: cn(theme.container, props.className, {
            [theme.disabled]: props.disabled
        }) },
        formattedOptions.map(option => (React.createElement("label", { key: option.key, "data-test-id": "element", className: cn(theme.element, {
                [theme.element_active]: selectedOption === option.key,
                [theme.element_error]: props.error
            }) },
            React.createElement("input", { type: "radio", name: `${props.name}_${option.key}`, value: option.key, onChange: onChange, checked: selectedOption === option.key, disabled: props.disabled }),
            option.icon))),
        props.error && React.createElement("p", { className: theme.error }, props.error)));
};
